<template>
    <div class="containers">
        <div class="area-list">
            <CAlert
            v-if="success == true"
            :show.sync="currentAlertCounter"
            closeButton
            style="background-color:rgba(48, 107, 221, 1);border-radius:0;text-align:center;color:white"
            >
            {{alertMess}}
            </CAlert>
            <CAlert
            v-else
            :show.sync="currentAlertCounter"
            closeButton
            style="background-color:red;border-radius:0;text-align:center;color:white"
            >
            {{alertMess}}
            </CAlert>
            <div class="search-area">
                <CRow>
                    <CCol sm="2">
                        <model-select style="background-color:rgba(249, 250, 252, 1)" :options="isInternal" class="form-control" v-model="isInternalValue" placeholder="Jenis Surat"></model-select>
                    </CCol>
                    <CCol style="padding-right:4px;padding-left:4px" sm="4">
                        <div class="autocomplete">
                            <input type="text"
                                    class="form-control"
                                    @click="toggleVisibleUnit()"
                                    @blur="toggleCloseVisibleUnit()"
                                    v-text="selectedItemUnit ? selectedItemUnit['text'] : ''"
                                    v-model="queryUnit"
                                    @keydown.up="upUnit"
                                    @keydown.down="downUnit"
                                    @keydown.enter="selectItemUnit"
                                    placeholder="Pilih Unit Level"
                            >
                            <div class="popovers" v-show="visibleUnit">
                                <div class="options" v-if="matchesUnit.length != 0 && queryUnit.length != 0" ref="optionsList">
                                    <ul>
                                    <li v-for="(match, index) in matchesUnit"
                                        :key="index"
                                        :class="{ 'selected': (selectedUnit == index)}"
                                        @click="itemClickedUnit(index)"
                                        v-text="match['text']"></li>
                                    </ul>
                                </div>
                                <div class="options" v-if="matchesUnit.length == 0 && queryUnit.length != 0">
                                    Data Tidak Ditemukan
                                </div>
                                <div class="options" v-if="matchesUnit.length == 0 && queryUnit.length == 0">
                                    Start Typing...
                                </div>
                            </div>
                        </div>
                    </CCol>
                    <CCol sm="2">
                        <input type="text" onfocus="(this.type='date')" onblur="(this.type='text')" placeholder="Tanggal Mulai" v-model="dateStart" class="form-control"/>
                    </CCol>
                    <CCol sm="2">
                        <input type="text" onfocus="(this.type='date')" :disabled="dateStart==''" :min="dateStart" onblur="(this.type='text')" placeholder="Tanggal Selesai" v-model="dateEnd" class="form-control"/>
                    </CCol>
                    <CCol sm="2">
                        <CButton @click="findData()" type="button" class="btn btn-search">Cari</CButton>
                    </CCol>
                </CRow>
            </div>
            <div class="sticky1">
                <CRow>
                    <CCol sm="6">
                    </CCol>
                    <CCol sm="6">
                        <span style="float:right">
                            <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                            <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                            <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                            <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                        </span>
                        <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page" class="text-center rounded p-1" type="text">
                        <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="page" class="text-center rounded p-1" type="text">
                        <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
                        <img class="mt-1 mr-5" :src="moreIcon" width="20px" height="20px" style="float:right"/>
                        <img class="mr-5 mt-1" v-if="datas.length != 0" @click="getDownload()" style="float:right;cursor:pointer" :src="downloadIcon" title="export to excel"  width="20px" height="20px"/>
                        <img class="mr-5 mt-1" @click="reload()" :src="refreshIcon" :class="classReload" width="20px" height="20px" style="float:right;cursor:pointer"/>
                    </CCol>
                </CRow>
            </div>
            <Tables @sort="sorting" @history="historyData" @file="openFile" @show="showSurat" :data="datas" :th="dataTh" :td="dataTd" :styleTable="styleTable" :errors="errorMessage"></Tables>
        </div>
    </div>
    </template>
    
    <script>
    import Tables from '@/component/tableIBC'
    import { DataApi, DataApiUpload } from "@/service/DataApi";
    import { ModelSelect } from 'vue-search-select'
    export default {
        components: {
            Tables,
            ModelSelect
        },
        data() {
            return {
                success: true,
                activeTab: 0,
                refreshIcon: require('@/assets/menu/icon_refresh.svg'),
                moreIcon: require('@/assets/menu/icon_more.svg'),
                closeIcon: require('@/assets/menu/icon_close.svg'),
                downloadIcon: require('@/assets/menu/icon_download_excel.svg'),
                backIcon: require('@/assets/menu/icon_goback.svg'),
                dataTh: ['Nomor Surat', 'Jenis', 'Dari', 'Subjek', 'Tanggal Terbit', 'Creator', 'Lampiran', 'Surat'],
                dataTd: ['nomorSurat', 'internal', 'namaDari', 'Subjek', 'tanggalSurat', 'namaCreated', 'listLampiran', 'urlSurat'],
                styleTable: ['125px', '50px', '100px', '150px', '75px', '100px', '75px', '50px'],
                classReload: 'reloadOff',
                loading: false,
                alertMess: '',
                currentAlertCounter: 0,
    
                // pagination
                page: 1,
                size: 20,
                totalRow: 0,
                totalPage: 1,
                firstPage: 0,
                lastPage: 0,
    
                // filter
                isInternal: [],
                isInternalValue: {
                    value: null,
                    text: 'Semua Jenis Surat'
                },
                dateStart: '',
                dateEnd: '',
                // data search unit
                dataUnit: [],
                titleUnit:"Pilih Unit Level",
                selectedItemUnit: null,
                selectedUnit: 0,
                queryUnit: '',
                visibleUnit: false,
                idUnits: '',
                
                // datas
                datas: [],
    
                //error
                errorMessage: '',
    

                errDisposition: '',
                alertMess: '',
                currentAlertCounter: 0,
                flagSearch: false
            }
        },
        watch: {
            page() {
                window.scroll({
                    top:0,
                    left: 0,
                    behavior: 'smooth'
                });
            },
            queryUnit() {
                this.getDataUnit()
                this.flagSearch = true
            },
            isInternalValue() {
                this.flagSearch = true
            },
            dateStart() {
                if(this.dateStart == '') {
                    this.dateEnd = ''
                }
                this.flagSearch = true
            },
            dateEnd() {
                if(this.dateEnd < this.dateStart) {
                    this.dateEnd = this.dateStart
                }
                this.flagSearch = true
            }
        },
        computed: {
            matchesUnit() {
                if (this.queryUnit == '') {
                    return [];
                }
                return this.dataUnit.filter((item) => item['text'].toLowerCase().includes(this.queryUnit.toLowerCase()))
            },
        },
        methods: {
            /**
             * GET DATA
             */
            sorting(value) {
                //
            },
            getData() {
                if(this.flagSearch == true) {
                    this.page = 1
                }
                this.datas = []
                this.errorMessage = 'Sedang mencari data ...'
    
                let payload = {
                    filterUniversal: "",
                    isiSurat: "",
                    jenisSurat: "",
                    idUnit: this.idUnits,
                    limit: this.size,
                    namaDari: "",
                    namaKepada: "",
                    namaOnReview: "",
                    nomorSurat: "",
                    pageIn: this.page,
                    perihal: "",
                    sifatSurat: "",
                    status: "",
                    tanggalSuratDari: this.dateStart,
                    tanggalSuratKe: this.dateEnd,
                    tempatSurat: "",
                    tipe: "I",
                    internal: this.isInternalValue.value,
                    isRead: ""
                }
                DataApi.post("surat/lihat", payload)
                .then(res => {
                    let response = res.data
                    if(response.success == true) {
                        let temp = response.data.data
                        temp.forEach(e => {
                            e.isRead = '1'
                            this.datas.push(e)
                        });
                        this.totalRow = response.data.totalRow
                        this.firstPage = (((this.page - 1) * this.size) + 1 )
                        this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                        this.totalPage = Math.floor(this.totalRow/this.size)
                        let modAr = this.totalRow%this.size
                        if(modAr != 0) {
                            this.totalPage = this.totalPage + 1
                        } else {
                            //
                        }
                        setTimeout(() => {
                            this.getData();
                        }, 60000);
                    } else {
                        this.datas = []
                        this.totalRow = 0
                        this.firstPage = 0
                        this.lastPage = 0
                        this.totalPage = 1
                        this.errorMessage = response.message
                    }
                    this.flagSearch = false
                    // this.$store.state.loadingScreen = false
                })
            },
            findData() {
                this.getData()
            },
            showSurat(id) {
                this.$store.state.loadingScreen = true
                let ids = this.datas[id].unix
                let payload = {
                    unix: ids,
                    qr: '1'
                }
                DataApi.post("/export/surat/lihat", payload , {responseType: 'blob'})
                .then(res => {
                    this.$store.state.loadingScreen = false
                    let response = res.data
                    // let fileName = res.headers["content-disposition"].split("filename=")[1];
                    const url = URL.createObjectURL(new Blob([response], {
                        type: 'application/pdf'
                    }))
                    const link = document.createElement('a')
                    link.href = url
                    let title = this.datas[id].jenisSurat + ' - ' + this.datas[id].perihal
                    link.setAttribute('download', title)
                    document.body.appendChild(link)
                    link.click()
                })
            },
            openFile(val) {
                let id = val.split("##")[0]
                let ids = val.split("##")[1]
                let url = this.datas[id].listLampiran[ids].url
                this.showFile(url)
            },
            movePage(direction) {
                if(direction == 'prev') {
                    this.page = this.page -  1
                } else {
                    this.page = this.page +  1
                }
                this.getData()
            },
            validatePage(page) {
                if(page > this.totalPage) {
                    this.page = this.totalPage
                }
            },
            reload() {
                this.flagSearch = true
                this.getData()
                if (this.classReload == 'reloadOff') {
                    this.classReload = 'reloadOn'
                } else {
                    this.classReload = 'reloadOff'
                }
            },
    
            showFile(id) {
                this.$store.state.loadingScreen = true
                DataApiUpload.get('load/' + id)
                .then( res => {
                    let openWindow = res.config.baseURL + res.config.url
                    window.open(openWindow)
                    this.$store.state.loadingScreen = false
                })
            },
            getSearchJenisSurat() {
                this.isInternal = [
                    {
                        text: 'Semua Jenis Surat',
                        value: null
                    },
                    {
                        text: 'Internal',
                        value: '1'
                    },
                    {
                        text: 'Eksternal',
                        value: '0'
                    }
                ]
            },
            /**
             * SEARCH UNIT LEVEL
             */
            getDataUnit() {
                let unit = this.queryUnit
                let payload = {
                    limit: 10,
                    namaUnit: unit,
                    pageIn: 1,
                    namaParentUnit: '',
                    idUnit: ''
                }
                DataApi.post("unit/get", payload)
                .then(res => {
                    this.dataUnit = []
                    let response = res.data.data
                    let tempData = response.data
                    var i = 0;
                    for(i=0;i<tempData.length;i++) {
                        let onPush = ''
                        if(tempData[i].parentBidang == null || tempData[i].parentBidang == 'null') {
                            onPush = {
                                value: tempData[i].id,
                                text: tempData[i].bidang
                            }                      
                        } else {
                            onPush = {
                                value: tempData[i].id,
                                text: tempData[i].bidang + ' - ' + tempData[i].parentBidang                            
                            }
                        }
                        this.dataUnit.push(onPush)
                    }
                })
            },
            toggleVisibleUnit() {
                this.visibleUnit = true;
            },
            hideUnit() {
                this.visibleUnit = false;
            },
            toggleCloseVisibleUnit() {
                setTimeout(this.hideUnit, 1000);
            },
            itemClickedUnit(index) {
                this.selectedUnit = index;
                this.selectItemUnit();
            },
            selectItemUnit() {
                if (!this.matchesUnit.length) {
                return;
                }
                this.selectedItemUnit = this.matchesUnit[this.selectedUnit];
                this.visibleUnit = false;
                this.queryUnit = this.selectedItemUnit.text
                this.idUnits = this.selectedItemUnit.value
                if (this.shouldReset) {
                this.queryUnit = '';
                this.selectedUnit = 0;
                }
            },
            upUnit() {
                if (this.selectedUnit == 0) {
                return;
                }
                this.selectedUnit -= 1;
                this.scrollToItemUnit();
            },
            downUnit() {
                if (this.selectedUnit >= this.matchesUnit.length - 1) {
                return;
                }
                this.selectedUnit += 1;
                this.scrollToItemUnit();
            },
            scrollToItemUnit() {
                this.$refs.optionsList.scrollTop = this.selectedUnit * this.itemHeight;
            },
            getDownload() {
                this.$store.state.loadingScreen = true
                let payload = {
                    filterUniversal: "",
                    isiSurat: "",
                    jenisSurat: "",
                    idUnit: this.idUnits,
                    namaDari: "",
                    namaKepada: "",
                    namaOnReview: "",
                    nomorSurat: "",
                    perihal: "",
                    sifatSurat: "",
                    status: "",
                    tanggalSuratDari: this.dateStart,
                    tanggalSuratKe: this.dateEnd,
                    tempatSurat: "",
                    tipe: "I",
                    internal: this.isInternalValue.value,
                    isRead: ""
                }

                DataApi.post("export/surat/recap", payload , {responseType: 'blob'})
                .then(res => {
                    let response = res.data
                    console.log(response)
                    // let fileName = res.headers["content-disposition"].split("filename=")[1];
                    const url = URL.createObjectURL(new Blob([response], {
                        type: 'application/vnd.ms-excel'
                    }))
                    const link = document.createElement('a')
                    link.href = url
                    let jenisSurat = this.isInternalValue.value == null ? '' : ' ' + this.isInternalValue.text
                    let tanggalMulai = ' ' + this.dateStart
                    let tanggalSelesai = this.dateEnd == '' ? '' : ' - ' + this.dateEnd
                    let nameFile = 'Rekap Surat' + jenisSurat + tanggalMulai + tanggalSelesai
                    link.setAttribute('download', nameFile)
                    document.body.appendChild(link)
                    link.click()
                    this.$store.state.loadingScreen = false
                })
            }
        },
        mounted() {
            this.errorMessage = 'Find Your Data'
            this.getSearchJenisSurat()
        },
    }
    </script>
    <style scoped>
    input[type="checkbox"] {
        width: 15px;
        height: 15px;
    }
    .containers {
        background-color: white;
        border-bottom: 1px solid #e5e6e8;
    }
    .btn-search {
        border-radius: 4px;
        width: 100%;
        background-color:rgba(48, 107, 221, 1);
        color: white;
    }
    .btn-search:hover {
        border-radius: 4px;
        width: 100%;
        background-color:rgba(48, 107, 255, 1);
        color: white;
    }
    
    .btn-add {
        border-radius: 4px;
        width: 100%;
        border: 1px solid rgba(48, 107, 221, 1);
        background-color:white;
        color: rgba(16, 16, 16, 1);
        font-weight: 500;
        font-size: 14px;
    }
    .btn-add:hover {
        border-radius: 4px;
        width: 100%;
        border: 1px solid rgba(48, 107, 221, 1);
        background-color: rgba(48, 107, 221, 1);
        color: white;
    }
    .btn-cancel {
        border-radius: 4px;
        width: 200px;
        border: 1px solid rgba(48, 107, 221, 1);
        background-color:white;
        color: rgba(16, 16, 16, 1);
        font-weight: 500;
        font-size: 14px;
    }
    .btn-cancel:hover {
        border-radius: 4px;
        width: 200px;
        border: 1px solid rgba(48, 107, 221, 1);
        background-color: rgba(48, 107, 221, 1);
        color: white;
    }
    .reloadOn {
        float: left;
        cursor: pointer;
        transform: rotate(-180deg);
        transition: 300ms linear all;
    }
    .reloadOff {
        float: left;
        cursor: pointer;
        transform: rotate(180deg);
        transition: 300ms linear all;
    }
    div.search-area {
        padding-top: 12px;
        padding-left: 20px;
        padding-right: 20px;
        padding-bottom: 6px !important;
        background-color: white;
        z-index: 1;
    }
    div.sticky1 {
        position: -webkit-sticky;
        position: sticky;
        top: 54px;
        padding-top: 6px;
        padding-right: 20px;
        padding-left: 20px;
        padding-bottom: 12px !important;
        background-color: white;
        z-index: 1;
    }
    input {
        background-color: rgba(249, 250, 252, 1);
    }
    
    .area-edit {
        background-color: white;
        border-bottom: 1px solid rgba(238, 238, 238, 1);
    }
    .area-back {
        padding-left: 20px;
        padding-right: 20px;
        padding-top: 8px;
        padding-bottom: 8px;
    }
    .area-input {
        padding-left: 20px;
        padding-right: 20px;
        padding-top: 8px;
        padding-bottom: 8px;
    }
    .area-input label {
        font-size: 12px;
        color: rgba(154, 154, 154, 1);
        font-weight: 600;
        margin-bottom: 12px;
    }
    .area-input input, .area-input .model-select, .area-input .autocomplete, .area-input textarea {
        background-color: white;
        margin-bottom: 20px;
    }
    .area-button-submit {
        padding-left: 20px;
        padding-bottom: 20px;
    }
    .btn-edit-submit {
        border-radius: 4px;
        width: 200px;
        background-color:rgba(48, 107, 221, 1);
        color: white;
        font-size: 14px;
    }
    .btn-edit-delete {
        border-radius: 4px;
        float: left;
        width: 200px;
        background-color:red;
        color: white;
        font-size: 14px;
    }
    .alert-area {
        padding-left: 20px;
        padding-right: 20px;
        padding-top: 16px;
        padding-bottom: 16px;
        background-color: rgba(48, 107, 221, 1);
        text-align: center;
        color: white;
        font-size: 14px;
    }
    ::v-deep .nav-tabs .nav-item {
        flex-grow: 1;
        position: relative;
        background-color: transparent !important;
        border-top: none !important;
        border-left: none !important;
        border-right: none !important;
        border-bottom: 1px solid rgba(224, 224, 224, 1) !important;
        border-radius: 0px;
    }
    ::v-deep .nav-tabs .nav-link.active {
        border-top-left-radius: 0;
        border-top-right-radius: 0;
        border-color: transparent;
        background-color: white;
        border-bottom: 1px solid rgba(48, 107, 221, 1) !important;
        color: black;
        font-weight: bold;
    }
    .nav-tabs li a span {
        color: rgba(96, 96, 96, 1) !important;
        font-size: 12px;
    }
    .select-invalid {
        border: 1px solid #e55353 !important;
    }
    .select-valid {
        border: 1px solid #2eb85c !important;
    }
    .autocomplete {
        width: 100%;
        position: relative;
    }
    .input {
        cursor: text;
    }
    .close {
        position: absolute;
        right: 8px;
        top: 10px;
        background: none;
        border: none;
        font-size: 14px;
        color: lightgrey;
        cursor: pointer;
    }
    .placeholder {
        position: absolute;
        top: 7px;
        left: 16px;
        font-size: 14px;
        color: #d0d0d0;
    }
    .popovers {
        text-align: center;
        width: 100% !important;
        min-height: 50px;
        border: 1px solid #d8dbe0;
        position: absolute;
        top: 35px;
        padding-left: 8px;
        padding-right: 8px;
        padding-top: 8px;
        left: 0;
        right: 0;
        background: #fff;
        border-radius: 3px;
        text-align: center;
        z-index: 3;
    }
    .popovers input {
        right: 8px;
        left: 8px;
        width: 100%;
    }
    .options {
        max-height: 200px;
        overflow-y: auto;
        margin-top: 5px;
    }
    .options ul {
        list-style-type: none;
        text-align: left;
        padding-left: 0;
    }
    .options ul li {
        border-bottom: 1px solid lightgrey;
        padding: 10px;
        cursor: pointer;
        background: white;
    }
    .options ul li:first-child {
        border-top: 1px solid lightgray;
    }
    .options ul li:not(.selected):hover {
        background: whitesmoke;
        color: rgba(16, 16, 16, 1);
    }
    .options ul li.selected {
        background: whitesmoke;
        color: rgba(16, 16, 16, 1);
    }
    input:disabled {
        background-color: whitesmoke;
    }
    table {
        width: 100%;
    }
    table thead tr {
        background-color: rgba(244, 244, 244, 1);
    }
    thead th {
        padding-top: 16px;
        padding-left: 20px;
        padding-right: 20px;
        padding-bottom: 16px;
    }
    tbody td {
        padding-top: 8px;
        padding-bottom: 8px;
        padding-left: 20px;
        padding-right: 20px;
    }
    td,th {
        overflow-x: hidden !important;
        text-overflow: ellipsis;
        white-space: nowrap;
        border: 1px solid rgba(238, 238, 238, 1);
        font-size: 14px;
    }
    tr:nth-child(even) {
        background-color: rgba(252, 252, 252, 1);
    }
    .StepProgress {
        position: relative;
        padding-left: 45px;
        list-style: none;
    }
    .StepProgress::before {
        display: inline-block;
        content: '';
        position: absolute;
        top: 5px;
        left: 15px;
        width: 10px;
        height: 90%;
        border-left: 2px solid #CCC;
    }
    .StepProgress-item {
        position: relative;
        counter-increment: list;
    }
    .StepProgress-item:not(:last-child) {
        padding-bottom: 20px;
    }
    .StepProgress-item::before {
        display: inline-block;
        content: '';
        position: absolute;
        top: 10px;
        left: -30px;
        height: 100%;
        width: 10px;
    }
    .StepProgress-item::after {
        content: '';
        display: inline-block;
        position: absolute;
        top: 5px;
        left: -35px;
        width: 12px;
        height: 12px;
        border: 2px solid #CCC;
        border-radius: 50%;
        background-color: #FFF;
    }
    .StepProgress-item.is-done::before {
        border-left: 2px solid rgba(21, 100, 153, 1);
    }
    .StepProgress-item .is-done::after {
        font-size: 10px;
        color: #FFF;
        text-align: center;
        border: 2px solid rgba(21, 100, 153, 1);
        background-color: rgba(21, 100, 153, 1);
    }
    .StepProgress strong {
        display: block;
    }
    label{
        margin: 0;
    }
    ::v-deep .modal-header {
        border-bottom: none !important;
    }
    .headers-modal {
        padding-top: 32px;
        padding-bottom: 32px;
        padding-left: 20px;
        padding-right: 20px;
        font-size: 18px;
        font-weight: bold;
        color: rgba(16, 16, 16, 1);
    }
    ::v-deep .ui.search.dropdown>.text {
        overflow: hidden !important;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 100%;
    }
    </style>